/***
 * Created by Issyah Ismail
 * A method to check and refer based on the product metafield blocked_dates
 */

/**
 * This function runs on every page to disabled adding to cart if product is
 * unavailable for that day
 * @product {object}: The product item
 **/

function checkProductAvailabilities() {
  if (localStorage != "undefined") {
    const orderAttributes = localStorage.getItem("order_now_cart_attributes");
    // this is the main product section
    const mainProduct = document.querySelector("product-info[data-product-id]");
    // list down all the available
    const productCardsArray = document.querySelectorAll(
      "[data-card-product-id]"
    );
    // list down all the bundle option if applicable
    const productOptions = document.querySelectorAll(
      "[data-product-option-id]"
    );

    if (!orderAttributes) {
      // we can hide the quick add here
      // no dates, remove the quick add
      if (productCardsArray && productCardsArray.length) {
        productCardsArray.forEach((elem) => {
          const quickAddButton = elem.querySelector(".quick-add.no-js-hidden");
          if (quickAddButton) {
            quickAddButton.setAttribute("hidden", "");
          }
        });
      }
      // convert the add to cart button to order now. and show the popup
      if (mainProduct) {
        const addToCartForm = mainProduct.querySelector(
          ".product-form__buttons"
        );
        console.log(addToCartForm);
      }
      return;
    }
    const orderAttributesObj = JSON.parse(orderAttributes);
    if (!orderAttributesObj.delivery_date) return;
    const delivery_date = orderAttributesObj.delivery_date;
    const delivery_time = orderAttributesObj.delivery_time;
    const pickup_location = orderAttributesObj?.pickup_location;
    if (productCardsArray && productCardsArray.length) {
      productCardsArray.forEach((elem) => {
        const isNotAvailable = renderNotAvailable(
          elem,
          delivery_date,
          pickup_location,
          delivery_time
        );

        if (isNotAvailable) {
          const badgeContainer = elem.querySelector(".card__badge");
          const notAvailableBadge = document.createElement("span");
          // if the quick add button is present, we need to hide it as well
          const quickAddButton = elem.querySelector(".quick-add.no-js-hidden");
          if (quickAddButton) {
            quickAddButton.setAttribute("hidden", "");
          }
          console.log(quickAddButton);
          notAvailableBadge.setAttribute(
            "class",
            "badge badge--bottom-left color-scheme-3"
          );
          notAvailableBadge.textContent =
            isNotAvailable?.message ?? "Not available";
          badgeContainer.appendChild(notAvailableBadge);
          const media = elem.querySelector(".card__media .media img");
          if (media) {
            media.style = "filter: opacity(0.3)";
          }
        }
      });
    }
    if (mainProduct) {
      const isNotAvailable = renderNotAvailable(
        mainProduct,
        delivery_date,
        pickup_location,
        delivery_time
      );
      if (isNotAvailable) {
        const submitButton = mainProduct.querySelector(".product-form__submit");
        submitButton.setAttribute("disabled", "disabled");
        submitButton.textContent = isNotAvailable?.message ?? "Not available";
      }
    }

    // product option
    if (productOptions && productOptions.length) {
      productOptions.forEach((elem) => {
        const isNotAvailable = renderNotAvailable(
          elem,
          delivery_date,
          pickup_location
        );

        if (isNotAvailable) {
          // remove the selector
          const title = elem.querySelector(
            ".product-option__item-selection-title"
          );
          const selector = elem.querySelector(
            ".product-option__quantity-selector"
          );
          title.setAttribute("style", "text-decoration:line-through;");
          if (selector) {
            selector.innerHTML = "Not available";
            selector.setAttribute("style", "width:50%;border:0;");
          }
        }
      });
    }
  }
}

/**
 * Render the badge for not available based on the product availability data attributes in the DOM element
 * @param {HTMLElement} elem: The element to check for data attribtues
 * @param {string} delivery_date: the delivery date
 * @param {string} pickup_location: The pickup location selected by the customer */
function renderNotAvailable(
  elem,
  delivery_date,
  pickup_location = null,
  delivery_time = null
) {
  if (!elem || !delivery_date) return false;
  const productAvailabilityBlockedDates =
    elem.dataset["productAvailabilityBlockedDates"];
  const productAvailabilityBlockedDays =
    elem.dataset["productAvailabilityBlockedDays"];
  const productAvailabilityPickupStores =
    elem.dataset["productAvailabilityBlockedPickupStores"];

  const productLeadTimeHour = elem.dataset["productLeadTimeHour"];
  if (
    !productAvailabilityBlockedDates &&
    !productAvailabilityBlockedDays &&
    !productAvailabilityPickupStores &&
    !productLeadTimeHour
  ) {
    return false;
  }
  const date = dayjs(delivery_date, "DD MMM YY");
  if (productAvailabilityBlockedDates) {
    const datesArray = productAvailabilityBlockedDates.split(",");
    const dateFormat = date.format("YYYY-MM-DD");
    if (datesArray && datesArray.includes(dateFormat)) {
      return {
        status: true,
        message: `Not available on ${date.format("DD MMM")}`,
      };
    }
  }
  if (productAvailabilityBlockedDays) {
    const daysArray = productAvailabilityBlockedDays.split(",");
    const dateFormat = date.format("ddd");
    if (daysArray && daysArray.includes(dateFormat)) {
      return {
        status: true,
        message: `Not available on ${dateFormat}`,
      };
    }
  }

  if (productAvailabilityPickupStores) {
    // check if pickup location exists. Else ignore
    if (!pickup_location) return;

    const pickupLocations = productAvailabilityPickupStores.split(",");
    if (pickupLocations && pickupLocations.includes(pickup_location)) {
      return {
        status: true,
        message: `Not available for pickup at ${pickup_location}`,
      };
    }
  }

  // check the lead time for the product
  if (productLeadTimeHour) {
    const hour = parseInt(productLeadTimeHour);
    const compareDate = dayjs().add(hour, "hour");
    console.log("delivery_time:", delivery_time);
    const deliveryDateCompare = dayjs(delivery_date, "DD MMM YY");

    console.log("Compare date:", compareDate);
    console.log("deliveryDateCompare:", deliveryDateCompare);
    if (deliveryDateCompare.isBefore(compareDate, 'day')) {
      return {
        status: true,
        message: `Product requires at least ${hour} hour to prepare`,
      };
    }
    return false;
  }

  return false;
}

checkProductAvailabilities();
